module.exports = __webpack_public_path__ + "img/chart-pointer.fdd22ed0.svg";